import { LocaleLink } from "@/components/site/LocaleLink";
import { cn } from "@/lib/utils";
import { useT } from "@/lib/i18n/I18nProvider";

export function Pagination({
  page,
  totalPages,
  category,
}: {
  page: number;
  totalPages: number;
  category?: string;
}) {
  const { locale } = useT();
  const isBg = locale === "bg";
  if (totalPages <= 1) return null;
  const search = (p: number) => ({ page: p, ...(category ? { category } : {}) });
  const baseBtn =
    "inline-flex h-9 min-w-9 items-center justify-center rounded-full border border-border/60 px-3 text-[12.5px] font-medium transition-colors";
  const items: Array<number | "..."> = [];
  for (let i = 1; i <= totalPages; i++) {
    if (i === 1 || i === totalPages || Math.abs(i - page) <= 1) items.push(i);
    else if (items[items.length - 1] !== "...") items.push("...");
  }
  return (
    <nav className="mt-12 flex flex-wrap items-center justify-center gap-2" aria-label="Pagination">
      <LocaleLink
        to="/blog"
        search={search(Math.max(1, page - 1))}
        className={cn(baseBtn, page === 1 ? "pointer-events-none opacity-40" : "hover:bg-secondary")}
        aria-disabled={page === 1}
      >
        {isBg ? "← Назад" : "← Prev"}
      </LocaleLink>
      {items.map((it, idx) =>
        it === "..." ? (
          <span key={`e${idx}`} className="px-2 text-muted-foreground">…</span>
        ) : (
          <LocaleLink
            key={it}
            to="/blog"
            search={search(it)}
            className={cn(baseBtn, it === page ? "bg-foreground text-background" : "hover:bg-secondary")}
            aria-current={it === page ? "page" : undefined}
          >
            {it}
          </LocaleLink>
        ),
      )}
      <LocaleLink
        to="/blog"
        search={search(Math.min(totalPages, page + 1))}
        className={cn(baseBtn, page === totalPages ? "pointer-events-none opacity-40" : "hover:bg-secondary")}
        aria-disabled={page === totalPages}
      >
        {isBg ? "Напред →" : "Next →"}
      </LocaleLink>
    </nav>
  );
}